import React, { Component } from 'react';
import './alert.scss';
import { GECKO_CONSTS } from '../../';
import { GeckoAlertModel } from '../../models';
import { GeckoIcon } from '../';

class GeckoAlert extends Component {
  prepareClass() {
    return GECKO_CONSTS.ALERT_CLASSES[
      this.props.type || GECKO_CONSTS.ALERT_TYPE_INFO
    ];
  }

  renderClass() {
    return `gecko-alert alert ${this.prepareClass()}`;
  }

  renderIcon() {
    if (this.props.icon) {
      return <GeckoIcon icon={this.props.icon} />;
    }
    return null;
  }

  render() {
    return (
      <div
        className={this.renderClass()}
        role="alert"
        aria-label={this.props['aria-label']}
        aria-labelledby={this.props['aria-labelledby']}
        aria-live={this.props['aria-live'] || 'off'}
      >
        {this.renderIcon()}
        {this.props.children}
      </div>
    );
  }
}

GeckoAlert.propTypes = GeckoAlertModel;

export default GeckoAlert;
